/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uref.vue?vue&type=template&id=93c4faf4&scoped=true"
import script from "./uref.vue?vue&type=script&lang=js"
export * from "./uref.vue?vue&type=script&lang=js"
import style0 from "./uref.vue?vue&type=style&index=0&id=93c4faf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c4faf4",
  null
  
)

export default component.exports